var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.681,
    height: 12.681,
    viewBox: "0 0 12.681 12.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30609",
    "data-name": "Rectangle 30609",
    width: 4,
    height: 8,
    transform: "translate(4.461 2.34)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78766",
    "data-name": "Path 78766",
    d: "M6.34,0a6.34,6.34,0,1,0,6.34,6.34A6.34,6.34,0,0,0,6.34,0ZM5.812,3.426H6.868V7.4H5.812Zm.528,5.82a.528.528,0,1,1,.528-.528A.529.529,0,0,1,6.34,9.246Z",
    fill: "#e83e27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/disclaimer.85adf4f2432deb4821be1a4853b6739d.svg";
export { ForwardRef as ReactComponent };